<template lang="pug">
  tr.row.row-title
    th.col.blank
    th.col.blank
    th.col.check
      label.checkbox
        input(type="checkbox", :checked="checked", :disabled="isGlobalLocked", @click="check")
    th.col(v-for="v in columns", v-if="displayedColumns.includes(v.key)", :class="v.key")
      span(v-if="!v.sort") {{ v.label }}
      a(v-else @click="clickColumn(v)" :title="sortTitle(v)")
        | {{ columnLabel(v) }}
        span.sort-icon
          i.fa.fa-caret-down(v-if="order === v.key && orderDirection === 'desc'")
          i.fa.fa-caret-up(v-if="order === v.key && orderDirection === 'asc'")
    th.col
</template>

<script>
  import { mapGetters, mapMutations, mapState } from 'vuex'
  import { salaryTypes } from '../../constants'

  export default {
    props: ['checked'],
    computed: {
      ...mapGetters('common', ['isGlobalLocked']),
      ...mapState({
        columns: state => state.jobTableConfiguration.columns,
        displayedColumns: state => state.jobTableConfiguration.displayedColumns,
        order: state => state.searchJob.query.order,
        orderDirection: state => state.searchJob.query.orderDirection,
      }),
      // いま表示されている一覧に適用されている給与種別。「すべて」(0) と未選択は null。
      // Vuex の searchJob.query ではなく route query を見る。前者はサイドバーで
      // ラジオを選んだ時点（検索ボタンを押す前）に書き換わるため、
      // 画面に出ている結果と食い違った種別名を出してしまう。
      // 一覧は job/fetchIndex が route query から取得している。
      selectedSalaryType () {
        return salaryTypes.find(t => t.code === String(this.$route.query.salaryCd)) || null
      },
    },
    methods: {
      ...mapMutations('jobTableConfiguration', ['sort']),
      check (event) {
        this.$emit('check', { event })
      },
      // 給与は時給1,300円と月給230,000円が同じ列に入るため、種別が決まらないと大小比較が成立しない。
      // 種別未選択のときはソートせず、サイドバーの給与条件へ誘導する。
      sortable (column) {
        if (column.sortRequires !== 'salaryCd') return true
        return !!this.selectedSalaryType
      },
      columnLabel (column) {
        if (column.sortRequires === 'salaryCd' && this.selectedSalaryType) {
          return `${column.label}（${this.selectedSalaryType.name}）`
        }
        return column.label
      },
      sortTitle (column) {
        if (column.sortRequires !== 'salaryCd') return null
        return this.selectedSalaryType
          ? `${this.selectedSalaryType.name}の下限額で並べ替えます`
          : '給与で並べ替えるには、検索条件で給与の種別（時給・日給・月給・年収）を選んでください'
      },
      clickColumn (column) {
        if (!this.sortable(column)) {
          this.$emit('requireSalaryType')
          return
        }
        this.changeOrder(column.key)
      },
      changeOrder (field) {
        let newOrderDirection = 'desc'
        if (field === this.order) {
          newOrderDirection = (this.orderDirection === 'desc') ? 'asc' : 'desc'
        }
        this.$emit('searchOrderBy', field, newOrderDirection)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobTableHeader.vue